import Seo from "@/lib/Seo";
import PageHero from "@/components/common/PageHero";

export default function Cookies() {
  return (
    <>
      <Seo
        title="Gestion des cookies"
        description="Politique de gestion des cookies du site EDUCASER GROUP : types de cookies, finalités et gestion de votre consentement."
        path="/cookies"
      />
      <PageHero
        breadcrumb={[{ label: "Accueil", to: "/" }, { label: "Gestion des cookies" }]}
        title="Gestion des cookies"
      />
      <div className="bg-white py-16 lg:py-24">
        <div className="mx-auto max-w-3xl space-y-8 px-5 text-slate-600 lg:px-8">
          <div>
            <h2 className="font-display text-xl font-bold text-brand-blue">Qu'est-ce qu'un cookie ?</h2>
            <p className="mt-3">
              Un cookie est un petit fichier texte déposé sur votre terminal lors de la visite d'un site.
              Il permet notamment d'assurer le bon fonctionnement du site et de mesurer son audience.
            </p>
          </div>
          <div>
            <h2 className="font-display text-xl font-bold text-brand-blue">Les cookies que nous utilisons</h2>
            <ul className="mt-3 space-y-2">
              <li><strong className="text-brand-blue">Cookies essentiels :</strong> nécessaires au fonctionnement du site (navigation, sécurité). Ils ne requièrent pas votre consentement.</li>
              <li><strong className="text-brand-blue">Cookies de mesure d'audience :</strong> statistiques de fréquentation anonymisées, soumis à votre consentement.</li>
              <li><strong className="text-brand-blue">Cookies tiers :</strong> contenus intégrés (vidéo YouTube par exemple), déposés uniquement après votre action.</li>
            </ul>
          </div>
          <div>
            <h2 className="font-display text-xl font-bold text-brand-blue">Gérer votre consentement</h2>
            <p className="mt-3">
              Lors de votre première visite, un bandeau vous permet d'accepter ou de refuser les cookies non
              essentiels. Vous pouvez à tout moment modifier votre choix depuis les paramètres de votre
              navigateur, qui permet également de supprimer les cookies déjà enregistrés.
            </p>
          </div>
          <div>
            <h2 className="font-display text-xl font-bold text-brand-blue">Durée de conservation</h2>
            <p className="mt-3">
              Les cookies sont conservés pour une durée maximale de 13 mois. Au-delà, votre consentement
              vous est à nouveau demandé.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
